import React from 'react'

export const AddWorkflowEvidenceFormDescription = (): JSX.Element => (
  <span>{'Select a workflow preset or create a task destination'}</span>
)
